import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgxEchartsModule } from "ngx-echarts";
import { MaterialModule } from "../shared/material.module";
import { ParameterFilterBoxComponent } from "../shared/parameter-filter-box/parameter-filter-box.component";
import { SharedModule } from "../shared/shared.module";
import { ZorroModule } from "../shared/zorro.module";
import { CustomTableComponent } from "./project-view/data-table/custom-table/custom-table.component";
import { DataTableComponent } from "./project-view/data-table/data-table.component";
import { FlowchartComponent } from "./project-view/flowchart/flowchart.component";
import { Flowchart2Component } from "./project-view/flowchart2/flowchart2.component";
import { ImagePanelComponent } from "./project-view/image-panel/image-panel.component";
import { ModelTableComponent } from "./project-view/model-table/model-table.component";
import { ParameterOverviewComponent } from "./project-view/parameter-overview/parameter-overview.component";
import { ProjectTableComponent } from "./project-view/project-table/project-table.component";
import { ChartSliceComponent } from "./project/chart-slice/chart-slice.component";
import { D3ImageComponent } from "./project/shot-image/d3-image/d3-image.component";
import { ShotsGraphComponent } from "./project/shot-image/shots-graph/shots-graph.component";
import { TablesComponent } from "./project/tables/tables.component";
import { EnvVarsComponent } from "./project/env-vars/env-vars.component";
import { EnvVarsComponent as ProjectViewEnvVarsComponent } from "./project-view/env-vars/env-vars.component";
import { StorageTableComponent } from './project-view/storage-table/storage-table.component';
import { JobGroupsComponent } from './project-view/job-groups/job-groups.component';
import { JobGroupsInnerTableComponent } from './project-view/job-groups/job-groups-inner-table/job-groups-inner-table.component';
import { TraceFitsPlottingComponent } from './project-view/trace-fits-plotting/trace-fits-plotting.component';
import { CommonModule } from "@angular/common";
import { FieldsListingComponent } from './fields-listing/fields-listing.component';
import { ProjectDashboardComponent } from './project-view/project-dashboard/project-dashboard.component';
import { ProjectInformationComponent } from './project-view/project-dashboard/project-information/project-information.component';
import { HorizonsListingComponent } from './project-view/project-dashboard/horizons-listing/horizons-listing.component';
import { WellLogListingComponent } from './project-view/project-dashboard/well-log-listing/well-log-listing.component';
import { JobsFormComponent } from '../shared/forms/jobs-form/jobs-form.component';
import { ShotLinePlotComponent } from './project/shot-image/shot-line-plot/shot-line-plot.component';
import { SpatialPlottingV2Component } from './project/shot-image/spatial-plotting-v2/spatial-plotting-v2.component';
import { SourcePlottingComponent } from './project/shot-image/source-plotting/source-plotting.component';
import { ModelVisualizerComponent } from './project-view/model-visualizer/model-visualizer.component';
import { ModelVisualizerChartComponent } from './project-view/model-visualizer/model-visualizer-chart/model-visualizer-chart.component';
import { JobSubmissionComponent } from './project-view/job-submission/job-submission.component';
@NgModule({
  declarations: [
    ChartSliceComponent,
    ShotsGraphComponent,
    SpatialPlottingV2Component,
    SourcePlottingComponent,
    D3ImageComponent,
    TablesComponent,
    EnvVarsComponent,
    ProjectViewEnvVarsComponent,
    ProjectTableComponent,
    ParameterOverviewComponent,
    FlowchartComponent,
    DataTableComponent,
    ImagePanelComponent,
    CustomTableComponent,
    ModelTableComponent,
    ParameterFilterBoxComponent,
    Flowchart2Component,
    StorageTableComponent,
    JobGroupsComponent,
    JobGroupsInnerTableComponent,
    TraceFitsPlottingComponent,
    FieldsListingComponent,
    ProjectDashboardComponent,
    ProjectInformationComponent,
    HorizonsListingComponent,
    WellLogListingComponent,
    ShotLinePlotComponent,
    ModelVisualizerComponent,
    ModelVisualizerChartComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    ZorroModule,
    RouterModule,
    JobSubmissionComponent,
    NgxEchartsModule.forChild(),
    JobsFormComponent,
  ],
  exports: [
    ChartSliceComponent,
    ShotsGraphComponent,
    SpatialPlottingV2Component,
    SourcePlottingComponent,
    D3ImageComponent,
    TablesComponent,
    ProjectTableComponent,
    FieldsListingComponent,
  ],
  providers: [
    // {
    //   provide: NGX_ECHARTS_CONFIG,
    //   useFactory: () => ({ echarts: () => import("echarts") }),
    // },
  ],
})
export class ProjectModule {}
